(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      /* Medición de barra de anuncio → --announcement-height */
      const setAnnouncement = () => {
        const candidates = [
          document.getElementById('shopify-section-announcement-bar'),
          document.querySelector('[id^="shopify-section-announcement"]'),
          document.querySelector('.announcement-bar'),
          document.querySelector('.shopify-section-announcement-bar'),
          document.querySelector('[data-section-type*="announcement"]'),
          document.querySelector('[class*="announcement"][class*="bar"]')
        ].filter(Boolean);

        let h = 0;
        for (const el of candidates) {
          const rect = el.getBoundingClientRect();
          const cs = window.getComputedStyle(el);
          const visible = rect.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden';
          if (visible) { h = Math.round(rect.height); break; }
        }
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      };

      const ready = () => { setAnnouncement(); this.setHeaderHeight(); };
      ready();
      window.addEventListener('resize', setAnnouncement, { passive: true });
      window.addEventListener('load', ready, { once: true });

      const mo = new MutationObserver(() => setAnnouncement());
      mo.observe(document.documentElement, { childList: true, subtree: true });

      /* === NUEVO: detectar apertura/cierre del drawer para forzar header blanco en mobile === */
      const updateDrawerState = () => {
        const anyOpen = Array.from(document.querySelectorAll('details[id^="Details-menu-drawer"], header-drawer details, details.menu-drawer-container'))
          .some(d => d.hasAttribute('open'));
        document.documentElement.classList.toggle('drawer-open', anyOpen);
      };

      // Escuchar cambios en cualquier <details> del drawer
      document.addEventListener('toggle', (e) => {
        const el = e.target;
        if (el.matches('details[id^="Details-menu-drawer"], header-drawer details, details.menu-drawer-container')) {
          updateDrawerState();
        }
      }, true);

      // Inicial
      updateDrawerState();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
